
import { Component, Vue, Prop } from "nuxt-property-decorator";

@Component
export default class OnlyThree extends Vue {
  @Prop() gallery!: Array<any>;
}
